<template>
  <el-container v-loading="loading" id="top" style="height:1000px;">
    <el-header>
      <HeaderView :userName="viewUserName" />
    </el-header>
    <el-container>
      <el-container id="submenu" style="height:100%;overflow:auto;">
        <el-aside>
          <MenuView :cowMenuRadio="cow_menu_radio" :isAdmin="isAdmin" :userType="userType" :farmerId="farmer_id" />
        </el-aside>
      </el-container>
      <el-container id="sub" style="overflow:auto;">
        <el-main class="main">
          <el-scrollbar style="height: 100%;">
            <div class="main-inner">
              <div class="main-narrow">
                <h1 class="c-heading-a">個人情報保護について</h1>
                <p class="c-text">
                  株式会社ニコン（以下「当社」といいます）は、個人情報の適切な取扱いが非常に重要であるとの認識のもと、ニコングループ個人情報保護方針に基づき、個人情報について、次のとおり取り扱います。</p>

                <h2 class="c-heading-b">1. 個人情報の取得について</h2>
                <p class="c-text">個人情報を取得させていただくにあたっては、利用目的を特定し、必要な個人情報のみを、適法かつ公正な手段により取得させていただきます。</p>

                <h2 class="c-heading-b">2. 個人情報の利用について</h2>
                <p class="c-text">取得いたしました個人情報は、以下の利用目的に必要な範囲で利用させていただきます。</p>
                <ul class="c-list">
                  <li>商品・サービスの販売、修理及び点検、アフターサービス、カタログの送付など、お客様のご要望される商品やサービスを提供するため（ご要望を把握するための購入履歴、修理履歴などの蓄積も含みます。）</li>
                  <li>お客様の各種お問い合わせ、ご依頼、ご要望などに対応するため（より良い対応を行うためのお問い合わせ履歴などの蓄積も含みます。）</li>
                  <li>
                    ニコングループの商品及び製品の企画、開発、宣伝、販売・サービス活動に、お客様のご要望を反映させるための参考資料とするため（例えば、商品購入時のアンケート、お客様満足度調査、お問い合わせ履歴などがございます。）
                  </li>
                  <li>ニコングループの商品情報、企業情報、サービスまたはそれらに関連する情報を提供するため（例えば、カタログ、新製品情報、メールマガジン、ご愛用者向け冊子の送付などがございます。）</li>
                  <li>キャンペーン等において、諸連絡事項や当選可否の通知、当選景品などの送付のため</li>
                  <li>展示会や講習会等において、参加者の確認及びその後の連絡などを行うため</li>
                  <li>業務上のお取引先様との円滑なお取引関係の維持、構築のため</li>
                  <li>個人情報保護法その他法令で認められた利用目的に利用するため</li>
                </ul>
                <p class="c-text">また、取得いたしました個人情報を加工して、個人を特定できない状態としたうえで、統計的なデータとして利用することがあります。</p>

                <h2 class="c-heading-b">3. 第三者への提供等について</h2>
                <h3 class="c-heading-c">（1）第三者への提供について</h3>
                <p class="c-text">取得いたしました個人情報の第三者への提供につきましては、下記の場合を除き行いません。</p>
                <p class="c-text">事前に同意をいただいた場合<br />個人情報保護法その他の法令で認められた場合</p>
                <h3 class="c-heading-c">（2）業務委託先について</h3>
                <p class="c-text">
                  取得いたしました個人情報は、利用目的を達成するために必要な範囲内において、当社の業務委託先に対し個人情報を開示・提供することがあります。具体的には、お客様への配送物を配送会社に委託する場合などがあります。その場合当社は業務委託先に対し、守秘義務契約の締結などを行うとともに、お客様の個人情報を適切に管理するため厳正な管理監督を行います。
                </p>
                <h3 class="c-heading-c">（3）共同利用について</h3>
                <p class="c-text">取得いたしました個人情報は、ニコングループにおいて総合的サービスを提供するために、「2.
                  個人情報の利用について」に記載した利用目的の範囲に限り、ニコングループ各社で共同利用することがあります。共同利用する項目は「氏名、連絡先（住所、電話番号、メールアドレスなど）、商品購入履歴、修理履歴、お問い合わせ内容、ご依頼内容及びご要望の内容」とさせていただきます。この他の項目について共同利用する場合には、別途ご本人様に通知もしくは公表させていただきます。共同利用する個人情報の管理責任者は、株式会社ニコンとします。<br>
                  なお、ニコングループでは、ニコングループ共通の個人情報保護方針のもと、個人情報の安全管理を厳正に行っております。</p>
                <p class="c-text">ニコングループ各社は以下サイトに掲載しております。</p>
                <ul class="c-link-list">
                  <li><a href="https://www.jp.nikon.com/company/corporate/group/"
                      target="_blank">https://www.jp.nikon.com/company/corporate/group/</a></li>
                </ul>

                <h2 class="c-heading-b">4. 個人情報の適正な管理について</h2>
                <p class="c-text">
                  取得いたしました個人情報は、漏洩、滅失、毀損の防止、その他安全管理のため、ニコングループの個人情報保護方針及び当社の情報管理に関する諸規程等に基づき、必要かつ適切なセキュリティ対策を講じております。また、当社の役員、従業員その他関係者に対して、個人情報の適切な取扱いに必要な教育を行います。
                </p>
                <h2 class="c-heading-b">5. お問い合わせについて</h2>
                <p class="c-text">
                  個人情報についてのお問い合わせ窓口は、原則としてご本人様が個人情報をご提供された部門となります。ご自身の個人情報の利用目的を確認されたい場合や、個人情報の取扱いに関するご意見・苦情などについての窓口も同様となりますので、恐れ入りますが以下までお問い合わせください。
                </p>
                <ul class="c-link-list">
                  <li><a href="https://www.nsl.nikon.com/jpn/" target="_blank">https://www.nsl.nikon.com/jpn/</a></li>
                </ul>
                <p class="c-text">
                  ※ポップアップブロックを解除してアクセスしてください
                </p>

                <h2 class="c-heading-b">6. 見直しについて</h2>
                <p class="c-text">当社は、個人情報の保護に関連する日本の法令、その他の規範を遵守するとともに、上記内容を適宜見直すことにより、個人情報の保護につき継続的な改善を図ります。</p>

                <h2 class="c-heading-b">
                  <p class="c-text">株式会社ニコン<br />東京都品川区西大井 1-5-20<br />代表取締役 兼 社長執行役員 德成 旨亮</p>
                </h2>
              </div>
            </div>
          </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import HeaderView from '../components/HeaderView';
import MenuView from '../components/MenuView';
import { getCurrentUser, signout } from "./js/cognito";
import AWSAPI from './js/aws-api';
import { ElMessage } from 'element-plus';
import ConstParam from './js/const';

export default {
  name: 'PrivacyView',
  components: {
    HeaderView,
    MenuView,
  },
  created() {
    this.$store.commit('setCowMenuSelect', '> プライバシーポリシー');
  },
  mounted() {
    this.restore_param();
    this.get_current_user();
  },
  data() {
    return {
      userType: ConstParam.disable_user_kind,
      // ===== 以降固定 ====
      isAdmin: false,
      cow_menu_radio: "",
      loading: true,
      userData: {},
      farmer_id: "",
      viewUserName: "",
      viewFarmerName: "",
      logOut: false
      // ==================
    };
  },
  methods: {
    restore_param() {
      // パラメータ復元
      this.isAdmin = this.$store.state.userAdmin;
    },
    // ===== 以降固定 ====
    get_current_user: async function () {
      // ログイン済みユーザー取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getUserSp3()
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.userData = res['data']['data'][0];
          }
        });
    },
    get_id_token: async function () {
      try {
        const currentUser = await getCurrentUser();
        this.idToken = currentUser.idToken.jwtToken;
      } catch (e) {
        this.alertMessage("通知", ConstParam.relogin_message);
        this.$router.push('/login')
      }
    },
    viewMessage(message, status) {
      if (message === '') { return }
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status
        });
      } else {
        ElMessage.error(message);
      }
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    getAuthLevel(userData) {
      let ret = 0
      if ('user_type' in userData && userData.user_type) {
        ret = userData.user_type
      }
      return ret
    },
    getIsAdmin(authLevel) {
      let ret = true
      if (authLevel != 0) {
        ret = false
      }
      return ret
    }
  },
  watch: {
    // ===== 以降固定 ====
    userData: function () {
      if ('user_name' in this.userData) {
        this.viewUserName = this.userData['user_name'];
      }
      if ('farmer' in this.userData && 'farmer_name' in this.userData['farmer']) {
        this.viewFarmerName = this.userData['farmer']['farmer_name'];
      }
      if ('farmer' in this.userData && 'farmer_id' in this.userData['farmer']) {
        this.farmer_id = this.userData['farmer']['farmer_id'];
      }
      let tempUserType = this.getAuthLevel(this.userData)
      this.isAdmin = this.getIsAdmin(tempUserType)
      this.userType = tempUserType
      // パラメータ保存(権限)
      this.$store.commit('setUserAdmin', this.isAdmin);
      this.loading = false;
    }
    // ==================
  }
};
</script>

<style scoped>
.main {
  overflow: hidden;
  z-index: 1;
}

.main-inner {
  width: auto;
  max-width: 1400px;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 100px;
}

.main-narrow {
  max-width: 1280px;
  margin: 0 auto;
}

.c-heading-a {
  /* margin: 60px 0; */
  margin: 30px 0;
  position: relative;
  /* font-size: 4rem; */
  font-size: 36px;
  font-weight: 500;
  line-height: 1.5;
  color: #000;
}

.c-heading-b {
  /* margin: 100px 0 32px; */
  /* margin: 50px 0 16px; */
  margin: 2em 0 0.8em;
  /* font-size: 3rem; */
  font-size: 24px;
  font-weight: 500;
  line-height: 1.5;
  color: #000;
}

.c-heading-c {
  /* margin: 44px 0 24px; */
  /* margin: 22px 0 12px; */
  margin: 1em 0 0.6em;
  font-size: 2.4rem;
  font-weight: 500;
  line-height: 1.5;
  color: #000;
}

.c-text {
  /* margin-top: 20px; */
  /* margin-top: 10px; */
  margin-top: 0.5em;
  /* font-size: 1.6rem; */
  font-size: 16px;
  line-height: 1.9;
  color: #222;
}

.c-text-company {
  /* padding: 10px 0; */
  margin-block-start: 0;
  margin-block-end: 0;
}

.c-heading-a+.c-text {
  /* margin-top: 32px; */
  margin-top: 16px;
}

.c-link-list {
  /* margin-top: 20px; */
  margin-top: 10px;
}


.c-list {
  /* margin-top: 20px; */
  margin-top: 10px;
}

ul,
ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

.c-list li::before {
  content: "";
  display: inline-block;
  width: 0.375em;
  height: 0.375em;
  position: absolute;
  top: calc(0.5em * 1.25);
  left: 0;
  margin: 0;
  background: transparent url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHZpZXdCb3g9IjAgMCA2IDYiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01IC01KSI+PGNpcmNsZSBjeD0iMyIgY3k9IjMiIHI9IjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUgNSkiIGZpbGw9IiMyMjIiLz48L2c+PC9zdmc+) no-repeat center center;
  background-size: contain;
}

.c-list li:not(:first-child) {
  /* margin-top: 20px; */
  margin-top: 10px;
}

.c-list li {
  /* font-size: 1.6rem; */
  font-size: 16px;
  line-height: 1.5;
  color: #222;
  position: relative;
  padding-left: 0.875em;
}

/* ワードファイル適合のため追加 */
h1 {
  font-size: 20px !important;
}

h2 {
  font-size: 20px !important;
}

h3 {
  font-size: 20px !important;
}

p {
  line-height: 3em !important;
  font-size: 20px !important;
}

li {
  line-height: 3em !important;
  font-size: 20px !important;
}

.c-list li::before {
  top: calc(1.1em * 1.25) !important;
}
</style>